// This service will add classes to the popup element for typeahead
// this is normally a <ul> that has all of the results inside of it

// it uses the 'ap-typeahead-popup-classes' attribute that I defined
// if this attribute isn't used, then it won't add/change an classes

(function(angular) {
    'use strict';

    angular.module('aprima-core-ui').factory('typeaheadPopupClass', [
        'findTypeahead',
        typeaheadPopupClass,
    ]);

    function typeaheadPopupClass(
        findTypeahead
    ) {
        var typeaheadClasses = 'ap-typeahead-popup-classes';
        
        var service = {
            init: init,
        };

        return service;

        function init(popupElement, typeaheadElement) {
            if(!popupElement) {
                return;
            }

            typeaheadElement = typeaheadElement || findTypeahead(popupElement);
            if(!typeaheadElement) {
                return;
            }
            
            var popupClassesValue = typeaheadElement.attr(typeaheadClasses);
            if(popupClassesValue) {
                popupElement.addClass(popupClassesValue);
            }
        }
    }

})(window.angular);
